import React from 'react';
import theva from './img/5454.jpg'

function mcontent(){
    return(
        <div className="mcontent">
        <div class="text-xs md:text-center p-1 font-bold">
      <p>
      Welcome to the Personal website of Mr Thayananthan Thevathayarajh! (Under Development!)
      </p>
    </div>
    <figure class="flex  items-center justify-center p-1">
      <img class="w-40 h-40 rounded-full "  src={theva} alt="Theva's Face" ></img>     
      <div class="pt-6 md:p-8 text-left md:text-left space-y-1">            
          <p class="text-2xl text-black font-bold">
          Mr Thayananthan Thevathayarajh
          </p>
          <div class="text-blue-600 font-medium">
            <p>BTech (Hons) in Mechatronics</p>
            <p>Iyanar Kovilady Kokuvil West, Jaffna, Sri Lanka</p>
            <p>Tp: +94776187658</p>
            <p>Email: theva1993@gmail.com</p>
          </div>          
      </div>   
    </figure>
    </div>
    )
}

export default mcontent;     